import React, { useEffect, useState } from 'react';
import { UpOutlined } from '@ant-design/icons';

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => setIsVisible(window.scrollY > 250);

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <button
      type="button"
      aria-label="Back to top of list"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      style={{
        position: 'fixed',
        right: 20,
        bottom: 20,
        zIndex: 1050,
        width: 46,
        height: 46,
        border: 0,
        borderRadius: '50%',
        backgroundColor: '#87CEEB',
        color: '#fff',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
        cursor: 'pointer',
        fontSize: 20,
      }}
    >
      <UpOutlined />
    </button>
  );
};

export default BackToTopButton;
